import { render, staticRenderFns } from "./BalanceData.vue?vue&type=template&id=bb9a75c2&scoped=true&"
import script from "./BalanceData.vue?vue&type=script&lang=js&"
export * from "./BalanceData.vue?vue&type=script&lang=js&"
import style0 from "./BalanceData.vue?vue&type=style&index=0&id=bb9a75c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb9a75c2",
  null
  
)

export default component.exports